module.exports = __webpack_public_path__ + "img/edit.d46c87c2.svg";